import type { DataTableRef } from '@noorden-insurtech/alba-design-system';
import { useEffect, useRef } from 'react';

export function useDataTablePageSync<TData = unknown>(pageNo: number) {
  const ref = useRef<DataTableRef<TData>>(null);

  useEffect(() => {
    const targetPageIndex = Math.max(0, pageNo - 1);
    ref.current?.goToPage(targetPageIndex);
  }, [pageNo]);

  return ref;
}
